import React, { useCallback, useEffect, useState } from "react";
import { actionByID } from "../../Model/Auction";
import Lot from "./Lot";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Banner from "./Banner";

const View = () => {
  const [loading, setLoading] = useState(false);
  const [showHp, setShowhp] = useState("");
  const auctionID = localStorage.getItem("items");
  const [data, setData] = useState(undefined);
  const [islive, setIslive] = useState("");
  
  // const FetchBanner = useCallback(async () => {
  //   setLoading(true);
  // }, []);

  useEffect(() => {
    const getBanner = async () => {
      const results = await actionByID(auctionID);

      setData(results);
      // console.log("Dsadasd: ",results)
      results.map((val) => {
        setIslive(val.isLive)
        setShowhp(val.showHp);
      });

      setLoading(false);
    };
    getBanner().catch(console.error);
  }, []);



  const callMeta = async () => {
    let dataSend = {
      title: 'Art Auctions at Leon Gallery | Philippine Art & Masterpieces',
      discription: 'Explore upcoming and past art auctions at Leon Gallery. Discover Philippine masterpieces, rare collections, and renowned artists. Join our auctions for exclusive art opportunities.',
      lotNo: '',
      canonical: 'https://leon-gallery.com:/auctions',
      url: 'https://leon-gallery.com:/auctions',
      imagUrl: 'https://leon-gallery.com/static/media/dddd.f96bbcbee8c8c2f5e3ee.png',
    };

    await fetch(`https://leon-gallery.com:8081/meta`, {
      method: "POST",
      body: JSON.stringify(dataSend),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("data send here ", data);
      })
      .catch((error) => {
        // alert.error(error)
        console.log("error ", error);
      });
  }


useEffect(() => {
return callMeta();
},[])


  return (
    <div>
      {data ? (
        <>
          <Banner data={data} /> <Lot showHp={showHp} islive={islive} />
        </>
      ) : (
        <div
          style={{
            width: "100%",
            padding: 20,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box sx={{ display: "flex", position: "relative" }}>
            <span
              style={{
                position: "absolute",
                top: "10px",
                left: "2px",
                fontSize: 12,
              }}
            >
                Loading
            </span>
            <CircularProgress size="3rem" />
          </Box>
        </div>
      )}
    </div>
  );
};

export default React.memo(View);
